import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";
import { debounce } from "lodash";
import * as XLSX from "xlsx";

// Table styling for better header visibility and fit to screen
const tableStyles = `
    #printableTable {
        font-size: 0.7rem;
        width: 100%;
        table-layout: fixed;
        margin-bottom: 0;
    }
    #printableTable thead th {
        font-size: 0.65rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        font-weight: 600;
        vertical-align: middle;
        line-height: 1.1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    #printableTable tbody td {
        font-size: 0.7rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .table-responsive {
        overflow-x: visible;
        width: 100%;
    }
    @media (min-width: 1400px) {
        #printableTable thead th {
            font-size: 0.7rem;
            padding: 6px 4px;
        }
        #printableTable tbody td {
            font-size: 0.75rem;
            padding: 6px 4px;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = tableStyles;
    document.head.appendChild(styleSheet);
}

export default function ConsltPayment() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [devision, setDevision] = useState([]);
    const [subject, setSubjects] = useState([]);
    const [year, setYear] = useState([]);
    const [term, setTerm] = useState([]);
    const [fees, setFeesList] = useState([]);
    const [standard, setstandard] = useState([]);
    const [selclass, setselclass] = useState("");
    const [allStudent, setAllStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState("100");
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevYear, setselectedDevYear] = useState("");
    const [selectedDevStudType, setselectedDevStudType] = useState("");
    const [selectedDevStudAgentType, setselectedDevStudAgentType] = useState("");
    const [selectedDevStudTypeStd, setselectedDevStudTypeStd] = useState("");
    const [selectedFeesStud, setselectedFeesStud] = useState("");
    const [amount, setAmount] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [dueDateEnd, setDueDateEnd] = useState("");
    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [stYear, setstYear] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stAgent, setstAgent] = useState([]);
    const [agentTotals, setAgentTotals] = useState({});
    const [agentNames, setAgentNames] = useState({});
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [excludeZCancelled, setExcludeZCancelled] = useState(false);

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });

        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        http.get(`/year`).then((res) => {
            setstYear(res.data.data);
        });

        http.get(`/subject?login_user=${user.id}`).then((res) => {
            setSubjects(res.data.data);
        });

        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });

        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
            // Create a map of agent ID to agent name
            const agentMap = {};
            res.data.data.forEach(agent => {
                agentMap[agent.id] = agent.name;
            });
            setAgentNames(agentMap);
        });

        http.get(`/devision?login_user=${user.id}`).then((res) => {
            setDevision(res.data.data);
        });

        http.get(`/terms?login_user=${user.id}`).then((res) => {
            setTerm(res.data.data);
        });

        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setstandard(res.data.data);
        });

        http.get(`/year?login_user=${user.id}`).then((res) => {
            setYear(res.data.data);
        });
    }, []);

    const handleFilter = () => {
        const valueToSet = selectedStud ? selectedStud.value : " ";
        fetchTaskDetails(
            selectedClassStud,
            selectedDevStud,
            dueDate,
            dueDateEnd,
            selectedDevStudType,
            valueToSet,
            selectedDevStudTypeStd,
            selectedDevStudAgentType
        );
    };


    const fetchTaskDetails = (selectedClassStuds, selectedDevStuds, dueDates, dueDateEnds, typePay, student, std_type, agent) => {
        setIsLoading(true);
        //  Use new grouped API endpoint for Conslt Payment
        let endpoint = `/conslt_payment_grouped?class=${selectedClassStuds}&dev=${selectedDevStuds}&start_date=${dueDates}&end_date=${dueDateEnds}&type=${typePay}&student=${student}&company_id=${user.company_id}&std_type=${std_type}&agent=${agent}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };


    const handleSelectChangeClass = (event) => {
        setselectedClassStud(event.target.value);
    };

    const handleSelectChangeDev = (event) => {
        setselectedDevStud(event.target.value);
    };


    const handleSelectChangeStdType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };



    //real time year changing
    const handleSelectChangeYear = (event) => {
        setselectedDevYear(event.target.value);
        http.get(`/tution_feeslists?company_id=${user.company_id}&year=${event.target.value}`)
            .then((res) => {
                setFeesList(res.data.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };



    const handleSelectChangeDevType = (event) => {
        setselectedDevStudType(event.target.value);
    };

    const handleSelectChangeAgentType = (selectedOption) => {
        setSelectedAgent(selectedOption);
        setselectedDevStudAgentType(selectedOption ? selectedOption.value : "");
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };

    const handleAgentClick = (task) => {
        setModalData(task);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalData(null);
    };

    console.log('dueRepo', tasks);

    // Filter out Z CANCELLED classes when toggle is on
    const filteredTasks = excludeZCancelled 
        ? tasks.filter(task => !task.class || task.class.toUpperCase() !== 'Z CANCELLED')
        : tasks;

    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const initialState = {
        name: "",
    };

    const deleteTask = async (taskId) => {
        await http
            .delete(`/departments_del/${taskId}`)
            .then((response) => {
                toast.success("Departments Deleted successfully !");
                fetchTaskDetails();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };

    const options = allStudent.map((user) => ({
        value: user.id,
        label: `${user.adm_no} - ${user.ext_2}${user.ext_3} - ${user.class}${user.section}  - ${user.mobile}`,
    }));

    // Create agent options for react-select
    const agentOptions = stAgent.map((agent) => ({
        value: agent.name,
        label: agent.name,
    }));

    const handleClearFields = () => {
        window.location.reload();
    };

    const handleSubmit = async () => {
        if (tasks.length === 0 || !selectedFeesStud) {
            toast.error("Please select a student and fees type before submitting.");
            return true;
        }

        if (tasks.length === 0 || !selectedFeesStud || !amount || !dueDate) {
            toast.error("Please enter due date and amount");
            return;
        }


        try {
            const promises = [];

            for (let i = 0; i < tasks.length; i++) {
                const task = tasks[i];

                const formData = {
                    admn_no: task.admn_no,
                    ext_1: task.roll_no,
                    first_name: task.ext_2,
                    last_name: task.ext_3,
                    class: task.class,
                    dev: task.section,
                    fees_id: selectedFeesStud,
                    student_id: task.id,
                    amount: amount,
                    ext_5: dueDate,
                };

                // Push the promise for each API call to the array
                promises.push(http.post('/annual_fees', formData));
            }

            // Wait for all promises to be resolved
            await Promise.all(promises);

            // If all promises are resolved, show success toast
            toast.success("Fees data updated successfully");
            fetchTaskDetails(selectedStud, selectedClassStud, selectedDevStud, selectedFeesStud);

        } catch (error) {
            console.error("Error submitting tasks:", error);
        }
    };
    function handleSelectChangeFees(event) {
        setselectedFeesStud(event.target.value);
    }

    function handleChangeAmount(event) {
        setAmount(event.target.value)
    }

    function handleChangeDate(event) {
        setDueDate(event.target.value)
    }


    function handleChangeDateEnd(event) {
        setDueDateEnd(event.target.value)
    }



    const convertToExcel = () => {
        // Create data in the same order as displayed in the table
        const exportData = filteredTasks.map((task, index) => ({
            'No': index + 1,
            'Adm No': task.admn_no || '',
            'Student Name': `${task.first_name || ''} ${task.last_name || ''}`.trim(),
            'Class': task.class || '',
            'Div': task.dev || '',
            'Fee Type': task.std_type || '',
            'Master': parseFloat(task.total_master || 0),
            'Paid': parseFloat(task.total_paid || 0),
            'Due': parseFloat(task.total_due || 0),
            'Conslt': task.agent_name || '',
            'CONSLT Demand': parseFloat(task.conslt_demand || 0),
            'CONSLT Paid': parseFloat(task.total_conslt_paid || 0),
            'Balance': parseFloat(task.balance || 0)
        }));

        // Add totals row at the end
        exportData.push({
            'No': '',
            'Adm No': '',
            'Student Name': 'TOTAL',
            'Class': '',
            'Div': '',
            'Fee Type': '',
            'Master': totalSumMaster,
            'Paid': totalSumPaid,
            'Due': totalSum,
            'Conslt': '',
            'CONSLT Demand': totalConsltDemand,
            'CONSLT Paid': totalConsltPaid,
            'Balance': totalBalance
        });

        // Convert the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Conslt_Payment");
        XLSX.writeFile(wb, "conslt_payment_report.xlsx");
    };

    // Calculate totals from grouped data (using filteredTasks for accurate totals)
    const totalSum = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.total_due || 0);
    }, 0);

    const totalSumPaid = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.total_paid || 0);
    }, 0);

    const totalSumMaster = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.total_master || 0);
    }, 0);

    const totalConsltPaid = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.total_conslt_paid || 0);
    }, 0);

    const totalConsltDemand = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.conslt_demand || 0);
    }, 0);

    const totalBalance = filteredTasks.reduce((total, task) => {
        return total + parseFloat(task.balance || 0);
    }, 0);


    const handlePrint = () => {
        const content = `
            <html>
            <head>
                <title>Print Table</title>
                <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td {
                        border: 1px solid black;
                        padding: 8px;
                        text-align: left;
                    }
                    th {
                        background-color: #f2f2f2;
                    }
                </style>
            </head>
            <body>
                <table>
                    <thead>
                        <tr>
                            <th className="text-danger">No</th>
                            <th>Adm No</th>
                            <th>Student Name</th>
                            <th>Class</th>
                            <th>Division</th>
                            <th>Fee Type</th>
                            <th>Due Date</th>
                            <th>Type</th>
                            <th>Amount(Due)</th>
                            <th>Amount Paid</th>
                            <th>Amount Master</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tasks.map((task, index) => {
            const dueAmount = calculateDue(task.amount, task.ext_6);
            return `
                                <tr key=${index}>
                                    <td>${index + 1}</td>
                                    <td>${task.admn_no}</td>
                                    <td>${task.first_name} ${task.last_name}</td>
                                    <td>${task.class}</td>
                                    <td>${task.dev}</td>
                                    <td>${task.fees_name ? task.fees_name.name : ""}</td>
                                    <td>${task.ext_5}</td>
                                    <td>${task.std_type}</td>
                                    <td><b>${dueAmount}</b></td>
                                    <td><b>${task.ext_6}</b></td> 
                                    <td><b>${task.amount}</b></td>
                                </tr>
                            `;
        }).join('')}
                    </tbody>
                </table>
            </body>
            </html>
        `;


        const printWindow = window.open('', '', 'height=500, width=500');
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.print();
    };

    const calculateDue = (amount, ext_6) => {
        const due = amount - ext_6;
        return due;
    };

    // Format number without .00 if it's a whole number, and remove trailing zeros
    const formatNumber = (num) => {
        if (num === null || num === undefined || num === '') return '';
        const numValue = parseFloat(num);
        if (isNaN(numValue)) return '';
        // Format with commas and remove trailing zeros and decimal point if not needed
        return numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\.?0+$/, '');
    };
    return (
        <>
            <div className="container-fluid px-0">
                <Toaster position="top-right" reverseOrder={false} />

                <div className="row mt-3 px-4">
                    <div className="col-md-2  text-end">
                        <select onChange={handleSelectChangeClass} className="form-control">
                            <option value="">Select Class</option>
                            <option value="">All</option>
                            {stClass.map((option, index) => (
                                <option key={index} value={option.class_name}>
                                    {option.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1  text-end">
                        <select onChange={handleSelectChangeDev} className="form-control">
                            <option value=""> Div</option>
                            {stDev.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1  text-end ">
                        <select onChange={handleSelectChangeYear} className="form-control border border-danger">
                            <option value=""> Year</option>
                            {stYear.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={handleChangeDate} />
                    </div>
                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={handleChangeDateEnd}></input>
                    </div>
                    <div className="col-md-4 ">
                        <Select
                            options={options}
                            onChange={handleSelectChange}
                            value={selectedStud} // Set the selected value
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-3  text-end">
                        <select onChange={handleSelectChangeStdType} className="form-control">
                            <option value="">Select Type</option>
                            <option value="New">New</option>
                            <option value="Old">Old</option>
                        </select>
                    </div>




                    <div className="col-md-3  text-end">
                        <select onChange={handleSelectChangeDevType} className="form-control">
                            {loading ? (
                                <option>Loading...</option>
                            ) : (
                                <>
                                    <option value="">Fees Type</option>
                                    {fees.map((options, index) => (
                                        <option key={index} value={options.id}>
                                            {options.name}
                                        </option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>

                    <div className="col-md-2 form-group">
                        <Select
                            options={agentOptions}
                            onChange={handleSelectChangeAgentType}
                            value={selectedAgent}
                            placeholder="Select Agent"
                            isClearable
                            isSearchable
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '38px',
                                    fontSize: '14px'
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                })
                            }}
                        />
                    </div>

                    <div className="col-md-1">
                        <Link to="/conslt_payment" className="btn bt-sm btn-success" onClick={handleClearFields}>
                            Clear
                        </Link>
                    </div>

                    <div className="col-md-1">
                        <button className="btn bt-sm btn-success" onClick={convertToExcel}>
                            Export
                        </button>
                    </div>

                    <div className="col-md-1">
                        <button className="btn bt-sm btn-primary" onClick={handleFilter}>
                            Search
                        </button>
                    </div>

                    <div className="col-md-1">
                        <button 
                            className={`btn btn-sm ${excludeZCancelled ? 'btn-danger' : 'btn-outline-secondary'}`}
                            onClick={() => setExcludeZCancelled(!excludeZCancelled)}
                            title="Exclude Z CANCELLED classes"
                            style={{ fontSize: '0.75rem', padding: '6px 10px' }}
                        >
                            {excludeZCancelled ? '✓ ex-Z' : 'ex-Z'}
                        </button>
                    </div>
                </div>
                <hr className="mx-4" />
                <div className="row px-4">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : selectedClassStud == 100 ? (
                        <div className="alert alert-warning" role="alert">
                            Please select a class to filter!
                        </div>
                    ) : (
                        <div className="table-responsive">
                        <table id="printableTable" className="table table-striped center_tbl mt-2">
                            <thead className="table-primary">
                                <tr>
                                    <th style={{ width: '3%' }}>No</th>
                                    <th style={{ width: '7%' }}>Adm No</th>
                                    <th style={{ width: '12%' }}>Student Name</th>
                                    <th style={{ width: '15%' }}>Class</th>
                                    <th style={{ width: '5%' }}>Div</th>
                                    <th style={{ width: '10%' }}>Fee Type</th>
                                    
                                    <th style={{ width: '8%' }}>Master <br />(<b>{formatNumber(totalSumMaster)}</b>)</th>
                                    <th style={{ width: '8%' }}>Paid <br />(<b>{formatNumber(totalSumPaid)}</b>)</th>
                                    <th style={{ width: '8%' }}>Due <br />(<b>{formatNumber(totalSum)}</b>)</th>
                                    <th style={{ width: '7%' }}>Conslt</th>
                                    <th style={{ width: '8%' }}>CONSLT Demand <br />(<b>{formatNumber(totalConsltDemand)}</b>)</th>
                                    <th style={{ width: '8%' }}>CONSLT Paid <br />(<b>{formatNumber(totalConsltPaid)}</b>)</th>
                                    <th style={{ width: '8%' }}>Balance <br />(<b>{formatNumber(totalBalance)}</b>)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTasks.map((task, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{task.admn_no}</td>
                                        <td>{task.first_name} {task.last_name}</td>
                                        <td>{task.class}</td>
                                        <td>{task.dev}</td>
                                       
                                        <td>{task.std_type}</td>
                                        <td><b>{formatNumber(task.total_master)}</b></td>
                                        <td><b>{formatNumber(task.total_paid)}</b></td>
                                        <td><b>{formatNumber(task.total_due)}</b></td>
                                        <td>
                                            <b 
                                                onClick={() => handleAgentClick(task)} 
                                                style={{ 
                                                    cursor: 'pointer', 
                                                    color: '#0d6efd', 
                                                    textDecoration: 'underline' 
                                                }}
                                            >
                                                {task.agent_name}
                                            </b>
                                        </td>
                                        <td><b>{formatNumber(task.conslt_demand)}</b></td>
                                        <td><b>{formatNumber(task.total_conslt_paid)}</b></td>
                                        <td><b>{formatNumber(task.balance)}</b></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}
                </div>

                {/* Modal for Agent Details */}
                {showModal && modalData && (
                    <div 
                        className="modal fade show" 
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        onClick={closeModal}
                    >
                        <div 
                            className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
                            style={{ maxWidth: '850px' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-content">
                                <div className="modal-header border-bottom">
                                    <h5 className="modal-title">Consultant Payment Breakdown</h5>
                                    <button type="button" className="btn-close" onClick={closeModal}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                    
                                    {/* Student & Consultant Info */}
                                    <div className="row mb-3">
                                                <div className="col-md-6">
                                            <table className="table table-sm table-borderless mb-0">
                                                <tbody>
                                                    <tr><td className="text-muted" style={{width:'40%'}}>Student Name</td><td><strong>{modalData.first_name} {modalData.last_name}</strong></td></tr>
                                                    <tr><td className="text-muted">Adm No</td><td><strong>{modalData.admn_no}</strong></td></tr>
                                                    <tr><td className="text-muted">Class</td><td><strong>{modalData.class} - {modalData.dev}</strong></td></tr>
                                                </tbody>
                                            </table>
                                                </div>
                                                <div className="col-md-6">
                                            <table className="table table-sm table-borderless mb-0">
                                                <tbody>
                                                    <tr><td className="text-muted" style={{width:'40%'}}>Consultant</td><td><strong>{modalData.agent_name || 'N/A'}</strong></td></tr>
                                                    <tr><td className="text-muted">Type</td><td><strong>{modalData.std_type || 'N/A'}</strong></td></tr>
                                                    <tr><td className="text-muted">Fee Types</td><td><strong style={{fontSize:'0.85rem'}}>{modalData.fee_types || 'N/A'}</strong></td></tr>
                                                </tbody>
                                            </table>
                                                </div>
                                            </div>

                                    <hr className="my-3" />

                                    {/* Fee Summary */}
                                    <div className="row mb-3 text-center">
                                        <div className="col-4">
                                            <div className="p-2 border rounded">
                                                <small className="text-muted d-block">Master Amount</small>
                                                <h5 className="mb-0 mt-1"><strong>₹ {formatNumber(modalData.total_master)}</strong></h5>
                                        </div>
                                    </div>
                                        <div className="col-4">
                                            <div className="p-2 border rounded">
                                                <small className="text-muted d-block">Paid Amount</small>
                                                <h5 className="mb-0 mt-1 text-success"><strong>₹ {formatNumber(modalData.total_paid)}</strong></h5>
                                        </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="p-2 border rounded">
                                                <small className="text-muted d-block">Due Amount</small>
                                                <h5 className="mb-0 mt-1 text-danger"><strong>₹ {formatNumber(modalData.total_due)}</strong></h5>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Individual Fee Payment Details */}
                                    {modalData.fee_details && modalData.fee_details.filter(f => f.fee_name).length > 0 && (
                                        <>
                                            <h6 className="mb-2"><strong>Fee Payment Breakdown</strong></h6>
                                            <div className="table-responsive mb-3">
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="table-light">
                                                            <tr>
                                                            <th>Fee Type</th>
                                                            <th className="text-end">Master Amt</th>
                                                            <th className="text-end">Conslt Paid</th>
                                                            <th>Payment Details</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {modalData.fee_details.filter(f => f.fee_name).map((fee, index) => (
                                                                <tr key={index}>
                                                                <td><strong>{fee.fee_name}</strong></td>
                                                                <td className="text-end">₹ {formatNumber(fee.amount)}</td>
                                                                <td className="text-end text-success">₹ {formatNumber(fee.conslt_paid)}</td>
                                                                <td style={{fontSize:'0.85rem'}}>
                                                                    {fee.payments && fee.payments.length > 0 ? (
                                                                        fee.payments.map((payment, pIndex) => (
                                                                            <div key={pIndex} className="mb-1">
                                                                                <span className="text-muted">{payment.alt_date ? moment(payment.alt_date).format('DD-MM-YY') : moment(payment.created_at).format('DD-MM-YY')}</span>
                                                                                {' - '}
                                                                                <strong className="text-success">₹{formatNumber(payment.amount)}</strong>
                                                                                {payment.ext_1 && <span className="text-muted"> ({payment.ext_1})</span>}
                                                                                    </div>
                                                                        ))
                                                                    ) : (
                                                                        <span className="text-muted">-</span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                        </>
                                    )}

                                    <hr className="my-3" />

                                    {/* Consultant Payment Summary */}
                                    <h6 className="mb-2"><strong>Consultant Summary</strong></h6>
                                    <div className="row text-center">
                                        <div className="col-4">
                                            <div className="p-2 border rounded">
                                                <small className="text-muted d-block">CONSLT Demand</small>
                                                <h5 className="mb-0 mt-1"><strong>₹ {formatNumber(modalData.conslt_demand)}</strong></h5>
                                        </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="p-2 border rounded">
                                                <small className="text-muted d-block">CONSLT Paid</small>
                                                <h5 className="mb-0 mt-1 text-success"><strong>₹ {formatNumber(modalData.total_conslt_paid)}</strong></h5>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className={`p-2 border rounded ${modalData.balance >= 0 ? 'bg-warning-subtle' : 'bg-danger-subtle'}`}>
                                                <small className="text-muted d-block">Balance</small>
                                                <h4 className={`mb-0 mt-1 ${modalData.balance >= 0 ? 'text-warning' : 'text-danger'}`}>
                                                    <strong>₹ {formatNumber(modalData.balance)}</strong>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="alert alert-secondary mt-3 py-2 mb-0" role="alert" style={{fontSize:'0.85rem'}}>
                                        <strong>Note:</strong> CONSLT Demand is counted once per student.
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div >
        </>
    );
}

